// extracted by mini-css-extract-plugin
module.exports = {"up-btn":"BrowseDir_up-btn_3h-SH"};